/**
 * Códigos de erro de AGENDAMENTO que atravessam back → front.
 * Padrão: ERR_<DOMÍNIO>_<MOTIVO>.
 */
export const SCHEDULE_ERRORS = {
  /** 404 — agendamento não é da empresa de quem pediu, ou não existe (#4481). */
  NOT_FOUND: "ERR_NO_SCHEDULE_FOUND",
} as const;

export type ScheduleErrorCode = (typeof SCHEDULE_ERRORS)[keyof typeof SCHEDULE_ERRORS];
